import { Box, Typography } from '@mui/material';
import type { StrapiQuoteBlock } from '../types';

interface QuoteBlockProps {
  block: StrapiQuoteBlock;
}

export const QuoteBlock = ({ block }: QuoteBlockProps) => {
  return (
    <Box
      sx={{
        borderLeft: '4px solid',
        borderColor: 'primary.main',
        paddingLeft: '24px',
        paddingY: '16px',
        backgroundColor: 'rgba(0,0,0,0.02)',
        borderRadius: '8px',
      }}
    >
      {block.title && (
        <Typography variant="h6" fontWeight={600} gutterBottom>
          {block.title}
        </Typography>
      )}
      <Typography variant="body1" fontStyle="italic">
        {block.body}
      </Typography>
    </Box>
  );
};
